import { c as _c } from "react/compiler-runtime";
import { cn } from '@core/utils';
import { Rating } from '@/app/donation/_components/Rating';
interface ReviewSummaryProps {
  reviewRating?: number;
  reviewCount: number;
  className?: string;
}
export const ReviewSummary = t0 => {
  const $ = _c(20);
  const {
    reviewRating,
    reviewCount,
    className
  } = t0;
  let t1;
  if ($[0] !== className) {
    t1 = cn("mb-8 flex flex-row items-center justify-center gap-20 rounded-small border border-Gray-200 bg-Gray-25 px-20 py-40", "mobile-tablet:mb-24 mobile-tablet:flex-col mobile-tablet:items-start mobile-tablet:gap-6 mobile-tablet:p-20", className);
    $[0] = className;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  let t3;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <p className={cn("font-500 text-Gray-600 typo-body1", "mobile-tablet:typo-body4")}>답례품 만족도</p>;
    t3 = <div className="h-32 w-1 border-l border-Gray-300 mobile-tablet:hidden" />;
    $[2] = t2;
    $[3] = t3;
  } else {
    t2 = $[2];
    t3 = $[3];
  }
  const t4 = reviewRating ?? 0;
  let t5;
  if ($[4] !== t4) {
    t5 = <Rating value={t4} size={24} className="mr-16 mobile-tablet:mr-0" />;
    $[4] = t4;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = cn("font-700 text-Gray-900 typo-h3", "mobile-tablet:typo-h5");
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== reviewRating) {
    t7 = <p className={t6}>{reviewRating}</p>;
    $[7] = reviewRating;
    $[8] = t7;
  } else {
    t7 = $[8];
  }
  let t8;
  let t9;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t8 = <p className={cn("font-500 text-Gray-500 typo-h5", "mobile-tablet:typo-body3")}>/5.0</p>;
    t9 = cn("font-400 text-Gray-600 typo-body2", "mobile-tablet:typo-body4");
    $[9] = t8;
    $[10] = t9;
  } else {
    t8 = $[9];
    t9 = $[10];
  }
  let t10;
  if ($[11] !== reviewCount) {
    t10 = <p className={t9}>({reviewCount}개)</p>;
    $[11] = reviewCount;
    $[12] = t10;
  } else {
    t10 = $[12];
  }
  let t11;
  if ($[13] !== t10 || $[14] !== t5 || $[15] !== t7) {
    t11 = <div className="flex items-center gap-4">{t5}{t7}{t8}{t10}</div>;
    $[13] = t10;
    $[14] = t5;
    $[15] = t7;
    $[16] = t11;
  } else {
    t11 = $[16];
  }
  let t12;
  if ($[17] !== t1 || $[18] !== t11) {
    t12 = <div className={t1}>{t2}{t3}{t11}</div>;
    $[17] = t1;
    $[18] = t11;
    $[19] = t12;
  } else {
    t12 = $[19];
  }
  return t12;
};